export type RoleObjectTypeRow = Record<string, unknown>

export type PassportPermissionObjectType = {
  /** Ключ строки в модалке (catalog_object_type.id). */
  catalogId: number
  /** Сохраняется в passport_permissions.object_type_id. */
  permissionTypeId: number
  name: string
}

export function extractRoleObjectTypeRows(raw: unknown): RoleObjectTypeRow[] {
  if (Array.isArray(raw)) {
    return raw.filter(
      (item): item is RoleObjectTypeRow => Boolean(item) && typeof item === 'object',
    )
  }
  if (!raw || typeof raw !== 'object') return []

  const candidate = raw as Record<string, unknown>
  if (Array.isArray(candidate.data)) return extractRoleObjectTypeRows(candidate.data)
  if (Array.isArray(candidate.object_types)) return candidate.object_types as RoleObjectTypeRow[]
  if (Array.isArray(candidate.items)) return candidate.items as RoleObjectTypeRow[]
  if (Array.isArray(candidate.rows)) return candidate.rows as RoleObjectTypeRow[]

  return []
}

/** Типы элементов группы — как на /inventory/elements (elements-count). */
export function mapPassportPermissionElementTypes(
  rows: RoleObjectTypeRow[],
): PassportPermissionObjectType[] {
  return rows
    .filter((item) => !item.is_hide_element_list)
    .map((item) => {
      const id = Number(item.id)
      return {
        catalogId: id,
        permissionTypeId: id,
        name: String(item.object_name || item.name || `#${id}`),
      }
    })
    .filter((item) => Number.isFinite(item.catalogId) && item.catalogId > 0)
    .sort((a, b) => a.name.localeCompare(b.name))
}
